//Default icons
export var signInDefault = require('../../../assets/images/icon/signIn/sign_in.svg');
export var signOutDefault = require('../../../assets/images/icon/signout/sign-out.svg');
export var sizeChartDefault = require('../../../assets/images/icon/sizeChart/size_before.svg');
export var removeDefault = require('../../../assets/images/icon/remove/remove_new.svg');
export var wishlistDefault = require('../../../assets/images/icon/wishlist/wishlist_new.svg');
export var shopBagDefault = require('../../../assets/images/icon/shopBag/shopbag_new.svg');
export var storeDefault = require('../../../assets/images/icon/store/store_new.svg');
export var dropdownDefault = require('../../../assets/images/icon/dropdown/dropdown.svg');
export var navMenuDefault = require('../../../assets/images/icon/navMenu/nav_menu.svg');
export var filterDefault = require('../../../assets/images/icon/filter/filter.svg');
export var funnelDefault = require('../../../assets/images/icon/filter/funnel.svg');
export var closeDefault = require('../../../assets/images/icon/close/close.svg');
export var searchDefault = require('../../../assets/images/icon/search/search.svg');
export var switchAccount = require('../../../assets/images/icon/consumer/consumer.svg');
export var successDefault = require('../../../assets/images/icon/success/success.svg');
export var orderDefault = require('../../../assets/images/icon/order/orders.svg');
export var homeDefault = require('../../../assets/images/icon/home/home.svg');
export var editDefault = require('../../../assets/images/icon/edit/edit.svg');
export var imgs = require('../../../assets/images/a.png')
//Hover icons
var sizeChartHover = require('../../../assets/images/icon/sizeChart/size_hover.svg');
// var removeHover = require('../../../assets/images/icon/sizeChart/size_hover.svg');

//On Hover Function
export function hover(id) {
    if(id === "chart")
        document.getElementById(id).src = sizeChartHover
    else if(id === "remove")
        document.getElementById(id).src = removeDefault
  }
  
//On Mouse Out function  
export function unhover(id) {
    if(id === "chart")
        document.getElementById(id).src = sizeChartDefault  
    else if(id === "remove")
        document.getElementById(id).src = removeDefault  
  }